import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity, File, Link } from "../../../api/classes";
import { Avatar, Typography, List } from "@material-ui/core";
import CaseFile from "../components/file";
import FileUpload from "src/components/fileUpload";
import { DubitoSvc } from "src/api";
import { Permissions } from "src/api/constants";
import { hasPermissionOf } from "src/auth/auth";
import EmptyState from "src/components/emptyState";

interface Props {
  caseId: number;
  files: File[];
  onUpdate: () => void;
}
class CaseImages extends React.Component<Props> {
  componentWillMount() {}
  addImage = file => {
    DubitoSvc.addImage({
      case_id: this.props.caseId,
      file_id: file.id
    }).then(() => {
      this.props.onUpdate();
    });
  };
  render() {
    const { files } = this.props;
    const canEdit = hasPermissionOf(Permissions.EDIT_CASES);

    return (
      <div style={{ marginLeft: 12 }}>
        {canEdit && <FileUpload onUploaded={this.addImage} />}
        {files.length === 0 ? (
          <EmptyState message="There is no image yet" />
        ) : (
          <List>
            {files.map(a => {
              return <CaseFile file={a} />;
            })}
          </List>
        )}
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseImages);



// WEBPACK FOOTER //
// ./src/pages/cases/detail/images.tsx